export default __webpack_public_path__ + "images/57a8abfbf8e30873038abb51e712f4fa-seasonal_module_spd_festive_fun_desktop.webp";